export const useIntercom = () => {
  function getIntercomElement () {
    return document.querySelector('.intercom-launcher') ?? document.querySelector('[class^="intercom-with-namespace"]')
  }

  function showNewMessage (message) {
    if (window?.Intercom) {
      window.Intercom('showNewMessage', message)
    }
  }

  return {
    getIntercomElement,
    showNewMessage
  }
}
